import { Builder, ToManyRelation } from 'coloquent'
import { Commune } from '@/orrm/model/commune'
import { Departement } from '@/orrm/model/departement'
import { Phenomene } from '@/orrm/model/phenomene'
import { Fill, Stroke, Style } from 'ol/style'
import Link from '@/orrm/Link'
import { centroidsResource } from '@/api'
import AbstractClusterableNode from '@/orrm/model/AbstractClusterableNode'

export class Actualite extends AbstractClusterableNode {
  protected jsonApiType = 'node/orrm_actualite'
  protected static pageSize = 50
  public static readonly searchField = 'title'
  public static readonly layerId = 'actualites'
  public static readonly centroidsResourceGetter = centroidsResource.getActualitesCentroids

  public static readonly featureStyle = new Style({
    stroke: new Stroke({
      color: '#d45050',
      width: 1
    }),
    fill: new Fill({
      color: 'rgba(212, 80, 80, .2)'
    })
  })

  public static readonly clusterFeatureStyle = Actualite.clusterFeatureStyleFactory({
    stroke: Actualite.featureStyle.getStroke(),
    fill: new Fill({
      color: 'rgba(212, 80, 80, .5)'
    })
  })

  static getQueryBuilder (): Builder<Actualite> {
    return Actualite
      .with('field_orrm_commune')
      .with('field_orrm_departement')
      .with('field_orrm_phenomene') as Builder<Actualite>
  }

  get title (): string {
    return this.getAttribute('title')
  }

  get created (): Date {
    return this.getAttributeAsDate('changed')
  }

  get body (): Link | null {
    return this.getAttribute('body')
  }

  get country (): string {
    return this.getAttribute('field_orrm_pays')
  }

  get date (): Date {
    return this.getAttribute('field_orrm_date')
  }

  get link (): Date {
    return this.getAttribute('field_orrm_lien')
  }

  get _pageSize () {
    return Actualite.pageSize
  }

  field_orrm_commune (): ToManyRelation<Commune, this> { // eslint-disable-line
    return this.hasMany(Commune)
  }

  field_orrm_departement (): ToManyRelation<Departement, this> { // eslint-disable-line
    return this.hasMany(Departement)
  }

  field_orrm_phenomene (): ToManyRelation<Phenomene, this> { // eslint-disable-line
    return this.hasMany(Phenomene)
  }

  getCommunes (): Commune[] {
    return this.getRelation('field_orrm_commune')
  }

  getDepartements (): Departement[] {
    return this.getRelation('field_orrm_departement')
  }

  getPhenomenes (): Phenomene[] {
    return this.getRelation('field_orrm_phenomene')
  }
}
